import React, { useState } from 'react';
import styled from 'styled-components';
import isEmail from 'validator/lib/isEmail';
import FroalaInput from '../react-common/FroalaInput';

export interface Form801RejectionNotification {
  to: string;
  replyTo?: string;
  subject: string;
  body: string;
}

interface Form801InvalidMessageEditorProps {
  notification: Form801RejectionNotification;
  updateNotification: (
    rejectionNotification: Form801RejectionNotification,
  ) => void;
  setIsFormValid: (isFormInvalid: boolean) => void;
}

const Form801InvalidMessageEditor = (
  props: Form801InvalidMessageEditorProps,
) => {
  const { notification, updateNotification, setIsFormValid } = props;

  const [errors, setErrors] = useState({
    to: false,
    replyTo: false,
  });

  const onFieldChange = (field: string, value: string) => {
    updateNotification({ ...notification, [field]: value });

    const toError =
      field === 'to' ? !value.trim() || !isEmail(value) : errors.to;
    const replyToError =
      field === 'replyTo' ? !!value.trim() && !isEmail(value) : errors.replyTo;

    setErrors({ to: toError, replyTo: replyToError });
    setIsFormValid(!toError && !replyToError);
  };

  return (
    <div className="form-801-modal__invalid-message-editor-container">
      <div className="form-801-modal__invalid-message-editor">
        <form>
          <div className="form-group">
            <label>To:</label>
            <input
              value={notification.to || ''}
              onChange={e => onFieldChange('to', e.target.value)}
              className="form-control"
              type="text"
            />
            {errors.to && <StyledError>Invalid or missing email.</StyledError>}
          </div>
          <div className="form-group">
            <label>Reply-To:</label>
            <input
              value={notification.replyTo || ''}
              onChange={e => onFieldChange('replyTo', e.target.value)}
              className="form-control"
              type="text"
            />
            {errors.replyTo && <StyledError>Invalid Email.</StyledError>}
          </div>
          <div className="form-group">
            <label>Subject:</label>
            <input
              value={notification.subject || ''}
              onChange={e => onFieldChange('subject', e.target.value)}
              className="form-control"
              type="text"
            />
          </div>
        </form>
        <FroalaInput
          config={{
            width: '40em',
            height: 300,
          }}
          onModelChange={(newValue: string) => onFieldChange('body', newValue)}
          model={notification.body}
        />
      </div>
    </div>
  );
};

const StyledError = styled.div`
  font-size: 12px;
  margin: 2px 0 0 8px;
  color: red;
`;

export default Form801InvalidMessageEditor;
